import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/analytics'
// const debug = process.env.NODE_ENV !== 'production'
const debug = false



const firebaseConfig = {
  apiKey: "AIzaSyCjvS-Bfvf5o5AfERpi20BgMAf4xYtVCuI",
  authDomain: "sld-etax.firebaseapp.com",
  databaseURL: "https://sld-etax.firebaseio.com",
  projectId: "sld-etax",
  storageBucket: "sld-etax.appspot.com",
  messagingSenderId: "360684501775",
  appId: "1:360684501775:web:41d7f43839c2d14fc9dc7a",
  measurementId: "G-5QVXRKWEEL"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const db = firebase.firestore()
let cloudFunctionUrl = "";
let graphqlUrl = "";
let payment2c2pUrl = "";

if (firebase.analytics) {
  firebase.analytics()
}

if (debug) {
  db.settings({
    host: "localhost:8084",
    ssl: false
  });
  cloudFunctionUrl = "http://localhost:5001/sld-etax/us-central1/";
  graphqlUrl = "http://localhost/graphql/";
  payment2c2pUrl = "https://demo2.2c2p.com/2C2PFrontEnd/SecurePayment/PaymentAuth.aspx";

} else {
  cloudFunctionUrl = "https://us-central1-sld-etax.cloudfunctions.net/";
  graphqlUrl = "https://etax-web-backend-4pug4lsila-as.a.run.app/graphql/";
  payment2c2pUrl = "https://demo2.2c2p.com/2C2PFrontEnd/SecurePayment/PaymentAuth.aspx";
}

let getImageUrl = "https://images.phasicharoen.com/image_url/get?storage_location=";

const companies = db.collection("Companies")
const users = db.collection("Users")

const auth = firebase.auth()
const storage = firebase.storage()
const timestampNow = firebase.firestore.Timestamp.now();

export default {
  db,
  storage,
  auth,
  companies,
  users,
  cloudFunctionUrl,
  graphqlUrl,
  getImageUrl,
  payment2c2pUrl,
  analytics: firebase.analytics(),
  timestampNow,
}
